export default __webpack_public_path__ + "static/media/198.1165c15b.jpg";